import { Col, FormCheck, FormLabel, FormSelect, Row } from "react-bootstrap";
import { useState } from "react";
import RollDice from "../dice-rolling";

export default function MastDamage() {
	const [moveRate, setMoveRate] = useState("Battle");
	const [shipSize, setShipSize] = useState("Very Small");
	const [isMerchantShip, setIsMerchantShip] = useState(false);
	const [mastDamageRollResult, setMastDamageRollResult] = useState("");

	function rollForMastDamage() {
		let shipSizeModifier: number = 0;

		switch (moveRate) {
			case "Maneuver":
				shipSizeModifier = 1;
				break;
			case "Ramming":
				shipSizeModifier = -2;
				break;
			default:
				break;
		}

		const modifiedDieRoll: number = RollDice(1)[0] + shipSizeModifier + (isMerchantShip ? 2 : 0);

		if (modifiedDieRoll < 4)
			setMastDamageRollResult("Mast Broken");
		else
			setMastDamageRollResult("No Effect");
	}

	return (
		<>
			<Row>
				<Col>
					<h1>Mast Damage Table</h1>
				</Col>
			</Row>
			{mastDamageRollResult === "" ? null : (
				<Row className="p-3 text-center">
					<Col>
						<h1 className={mastDamageRollResult === "Mast Broken" ? "text-danger" : "text-success"}>{mastDamageRollResult}</h1>
					</Col>
				</Row>
			)}
			{mastDamageRollResult !== "Mast Broken" ? null : (
				<Row className="text-center">
					<Col>
						<p>Roll {(shipSize === "Very Small" || shipSize === "Small") ? "once" : shipSize === "Medium" ? "twice" : "three times"} on &quot;Range 2&quot; on the <a href="artillery-hits-on-ships">Artillery Hits On Ships Table</a>.</p>
					</Col>
				</Row>
			)}
			<Row className="my-3">
				<Col>
					<FormLabel htmlFor="move-rate">Move Rate</FormLabel>
					<FormSelect id="move-rate" value={moveRate} onChange={(e) => setMoveRate(e.target.value)}>
						<option value="Maneuver">Maneuver Move Rate</option>
						<option value="Battle">Battle Move Rate</option>
						<option value="Ramming">Ramming Move Rate</option>
					</FormSelect>
				</Col>
				<Col>
					<FormLabel htmlFor="ship-size">Ship Size</FormLabel>
					<FormSelect id="ship-size" value={shipSize} onChange={(e) => setShipSize(e.target.value)}>
						<option value="Very Small">Very Small</option>
						<option value="Small">Small</option>
						<option value="Medium">Medium</option>
						<option value="Large">Large</option>
						<option value="Very Large">Very Large</option>
					</FormSelect>
				</Col>
			</Row>
			<Row>
				<Col>
					<FormCheck type="checkbox" label="Ship is a Merchant Ship" checked={isMerchantShip} onChange={(e) => setIsMerchantShip(e.target.checked)} />
				</Col>
			</Row>
			<Row className="mt-3">
				<Col xs={12}>
					<button className="btn btn-primary" onClick={() => rollForMastDamage()}>Roll for Mast Damage</button>
				</Col>
				<Col className="mt-3">
					<button className="btn btn-danger" onClick={() => setMastDamageRollResult("")}>Clear Results</button>
				</Col>
			</Row>
		</>
	);
}